// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    messagePreviewError: {
        defaultMessage: `Sorry, we're having trouble showing this image. `,
        description: 'Error message for preview not loading an image',
        id: 'be.messageCenter.previewError',
    },
});

export default messages;
